<!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
<script setup>
import LaisModal from 'dashboard/components-next/LaisModal.vue';
import LaisPrimaryButton from 'dashboard/components-next/LaisPrimaryButton.vue';

defineProps({
  show: { type: Boolean, default: false },
  isSaving: { type: Boolean, default: false },
});

defineEmits(['close', 'submit']);

const cep = defineModel('cep', { type: [String, Number], default: '' });
const numero = defineModel('numero', { type: [String, Number], default: '' });
const complemento = defineModel('complemento', {
  type: [String, Number],
  default: '',
});
</script>

<template>
  <!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
  <LaisModal
    :show="show"
    title="Completar endereço"
    max-width-class="max-w-[480px]"
    @close="$emit('close')"
  >
    <div class="grid gap-3">
      <p class="text-[13px] text-lais-text-muted">
        Preencha o complemento e número para concluir o vínculo deste imóvel ao
        condomínio.
      </p>
      <label
        class="text-[12px] font-semibold uppercase tracking-wide text-lais-text-muted"
      >
        CEP
      </label>
      <input
        v-model="cep"
        type="text"
        class="rounded-lais border border-lais-border px-3 py-2 text-[14px]"
        placeholder="00000-000"
      />
      <label
        class="text-[12px] font-semibold uppercase tracking-wide text-lais-text-muted"
      >
        Número
      </label>
      <input
        v-model="numero"
        type="text"
        class="rounded-lais border border-lais-border px-3 py-2 text-[14px]"
      />
      <label
        class="text-[12px] font-semibold uppercase tracking-wide text-lais-text-muted"
      >
        Complemento
      </label>
      <input
        v-model="complemento"
        type="text"
        class="rounded-lais border border-lais-border px-3 py-2 text-[14px]"
        placeholder="Apto, bloco, casa..."
      />
    </div>
    <template #footer>
      <div class="flex justify-end gap-2">
        <LaisPrimaryButton variant="ghost" @click="$emit('close')">
          Cancelar
        </LaisPrimaryButton>
        <LaisPrimaryButton :disabled="isSaving" @click="$emit('submit')">
          {{ isSaving ? 'Salvando...' : 'Salvar' }}
        </LaisPrimaryButton>
      </div>
    </template>
  </LaisModal>
</template>
